/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014, 2020
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'jquery',
	'doT',
	'../../../widgets/livewidget/nls/StringResources',
	'../../../lib/@waca/dashboard-common/dist/utils/FlyoutContentBase',
	'../../../data/models/ConditionalPalette',
	'text!./templates/ConditionalFlyoutView.html'
], function($, dot, stringResources, FlyoutContentBase, ConditionalPalette, RemoveHandleTemplate) {
	'use strict';


	var removeHandleTemplate = dot.template(RemoveHandleTemplate);

	var ConditionalFlyoutView = FlyoutContentBase.extend({
		init: function(options = {}) {
			ConditionalFlyoutView.inherited('init', this, arguments);
			this.visModel = options.visModel || options.viewOptions.visModel;
			this.widget = options.widget || options.viewOptions.widget;
			this.palette = options.palette || options.viewOptions.palette;
			this.slider = options.slider || options.viewOptions.slider;
			this.icons = options.viewOptions.icons;
			this.handlePosition = options.handlePosition || options.viewOptions.handlePosition;

			this.isVisible = false;
		},

		setFocus: function() {
			$('.conditionalFormattingIcon').parent().focus();
		},

		onPopupShown: function() {
			this.isVisible = true;
		},

		onPopupClosed: function() {
			this.isVisible = false;
		},

		onDeleteClicked: function() {
			this.popupParent.close();
			const options = ConditionalPalette.createUndoRedoTransactionOptionsId('removeStyle');
			this.palette.removeStyle(this.handlePosition, options);
			this.visModel.updateConditionalPalette().then((function () {
				this.slider.removeHandle(this.handlePosition);
			}).bind(this));
		},

		getRenderedHtml: function() {
			const trashIcon = this.icons.getIcon('common-remove-trash');
			var template = removeHandleTemplate({
				remove_slider_handle: stringResources.get('remove_slider_handle'),
				trashIcon: trashIcon.id
			});
			var $deleteButton = $(template).on('primaryaction', this.onDeleteClicked.bind(this));
			var markup = '<div class="toolbar"></div>';
			var $markup = $(markup).append($deleteButton);
			return $markup[0];
		}

	});
	return ConditionalFlyoutView;
});
